import React, { Component } from 'react';
import './Ace.css'
import { getMessages, get_LONG_CBP_RESPONSE } from '../../apiCalls/jobInfo';
import { RoundLoader } from "kx-common-components";
import Images from '../../config/images';
import moment from 'moment';
import _ from 'lodash';
import so71reasoncodes from './so71reasoncodes.js'
import MessageItem from '../../C88_App/formSections/messegaItem';
import MessageDetails from "../../CBSA_App/components/formComponents/messageDetails";

export default class AceResponse extends Component {
  constructor() {
    super();
    this.state = {
      messages: [],
      width: '500px',
      height: '500px',
      copySuccess: '',
      email: '',
      title: '',
      emailTitle: '',
      aceTitle: '',
      id: '',
      copied: false,
      loading: false,
    }

    this.getMessages = this.getMessages.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    AceResponse.getStatusColor = AceResponse.getStatusColor.bind(this);
  }

   getMessages(id) {
    this.setState({ loading: true })
    getMessages(id)
      .then((res) => {
        if(_.isEmpty(res.data.eventMessage)){
          this.setState({
            messages: [],
            aceTitle: "TEST ACE",
            emailTitle: "TEST",
          }, () => this.setState({ loading: false }))
          return;
        }
        let r = _.get(res, "data.eventMessage.context","") && res.data.eventMessage.context.split(':')
        let a = r[r.length - 1]
        r = 'Status: '.concat(a);
        let responseMsg = res.data.eventMessage.ediTxnResponse;
        if (window.shipmentCountry === 'CA') {
          responseMsg = res.data.eventMessage.cbsaTxnResponse;
        }
        if (window.shipmentCountry === 'GB') {
          responseMsg = res.data.eventMessage.responseMessages;
        }
        this.setState({
          messages: responseMsg,
          aceTitle: r,        
          emailTitle:  _.get(res, "data.eventMessage.context",""),
        }, () => this.setState({ loading: false }))
      })
      .catch(err => {
        this.setState({ 
            loading: false, 
            messages: [], 
            aceTitle: "Error",        
            emailTitle:  "" })
        console.error('GET_CBP_RESPONSE ERROR:', err);
      })
  }


  getDateForDetails(dateReceived){

    var d = new Date(parseInt(dateReceived));

    var myTimezone = "GMT";
    var myDatetimeFormat= "MMM DD YYYY hh:mm:ss a z";
    var myDatetimeString = moment(d).tz(myTimezone).format(myDatetimeFormat);
    myDatetimeString = myDatetimeString.substring(0,myDatetimeString.indexOf("GMT"))+ "EDT"


    return myDatetimeString
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  componentWillMount() {
    this.setState({ id: this.props.id })
  }

  componentWillUnmount() {
    this.setState({ loading: false })
  }

  componentDidMount() {
    this.getMessages(this.state.id)
  }

  static getStatusColor(status) {
    let color = '#CA443B'
    if(window.shipmentCountry==='CA' && status){
      if (status === 'CBSA_ACCEPTED'||  status === 'CBSA_FUNCTIONAL_ACKNOWLEDGED_ACCEPTED' || status.includes('RNS')) {
        color = '#008800'
      }  else if (status === 'CBSA_REJECTED' ||status === 'CBSA_FUNCTIONAL_ACKNOWLEDGED_REJECTED' ) {
        color = '#CA443B'
      }
    }

    else {
      if (status === 'ACCEPTED') {
        color = '#008800'
      } else if (status === 'WARNING' || status === 'ACCEPTED_WARNING') {
        color = 'orange'
      } else if (status === 'REJECTED' || status === 'MESSAGE_REJECTED') {
        color = '#CA443B'
      }
    }
    return color
  }

  render() {
    let datamassageCBP = (onerrecord,allrecords,myindex, onlyPriorityMessages) => {
      let mainreasoncode = '';
      if(!onerrecord)return "";
      let nextrecord = (allrecords[myindex+1]?.record||"")+"";
      let nextrecord2 = (allrecords[myindex+2]?.record||"")+"";
      try{
        mainreasoncode = allrecords[myindex-1].record.split(" ").filter(a=>a).find(a=>a.length==12 && a.length <14 && a.replace(/[^0-9]/g, '').length > 6).substring(2,4);
      } catch(e){}

      let longcbpresponsematch = onerrecord.match(/SAVED.AS.LONG_CBP_RESPONSE_(.*)$/i)
      if (longcbpresponsematch && !onlyPriorityMessages && longcbpresponsematch.length) {
        return <React.Fragment>
          <input type="button" style={{ cursor: 'pointer', fontWeight:'bold' }} onClick={() => {
            if (this.state[onerrecord + 'loading']) return;
            this.setState({ [onerrecord + 'loading']: true });
            get_LONG_CBP_RESPONSE(longcbpresponsematch[1]).then((respx) => {
              if (!respx?.data?.eventMessage?.responseFiles || !respx?.data?.eventMessage?.ediTxnResponse) {
                alert("DOC LOADING FAILED");
                this.setState({ [onerrecord + 'loading']: false });
                return;
              }

              let downloadableText = "";
              for (let onerow of respx?.data?.eventMessage?.ediTxnResponse[0]?.recordResponse) {
                downloadableText += "[" + onerow.record + "]\n";
              }
              function savXXe(filename, data) {

                const blob = new Blob([data], { type: 'text/csv' });
                if (window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveBlob(blob, filename);
                }
                else {
                  const elem = window.document.createElement('a');
                  elem.href = window.URL.createObjectURL(blob);
                  elem.download = filename;
                  document.body.appendChild(elem);
                  elem.click();
                  document.body.removeChild(elem);
                }
              }
              savXXe(respx?.data?.eventMessage?.responseFiles[0], downloadableText)
              this.setState({ [onerrecord + 'loading']: false });
            });
          }} value="⇓ DOWNLOAD" />&nbsp;&nbsp;&nbsp;

          <a style={{ cursor: 'pointer' }} onClick={() => {
            if (this.state[onerrecord + 'loading']) return;
            this.setState({ [onerrecord + 'loading']: true });
            get_LONG_CBP_RESPONSE(longcbpresponsematch[1]).then((respx) => {
              if (!respx?.data?.eventMessage?.responseFiles || !respx?.data?.eventMessage?.ediTxnResponse) {
                alert("DOC LOADING FAILED");
                this.setState({ [onerrecord + 'loading']: false });
                return;
              }
              let win = window.open("", respx?.data?.eventMessage?.responseFiles[0], "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (window.screen.width - 400) + ",height=" + (window.screen.height - 400) + ",top=200,left=200");

              let constructedHTML = "<table>"
              for (let onerow of respx?.data?.eventMessage?.ediTxnResponse[0]?.recordResponse) {
                constructedHTML += "<tr><td style='border:1px solid #ccc;font-family:monospace;'>[" + (onerow.record||"").replaceAll(" ","&nbsp;") + "]</td></tr>";
              }
              constructedHTML += "</table>";
              constructedHTML += "</body>";
              win.document.body.innerHTML = constructedHTML;
              this.setState({ [onerrecord + 'loading']: false });
            });
          }}>
          {this.state[onerrecord+'loading']?
            "Loading..."
            :
            onerrecord
      }
        </a>
        </React.Fragment>
      
      }

      let soseventyonematch = onerrecord.match(/^SO71.*\W+[0-9]+\W*$/);
      if(soseventyonematch){
        let recordsplit = onerrecord.split(/\W{4}/).map(a=>a.trim()).filter(a=>a)
        let myreason = so71reasoncodes
          .filter(a=>a.subreasoncode == recordsplit[1])
          .filter(a=>mainreasoncode?(a.reasoncode == mainreasoncode):true)
        return <>
          {onerrecord.trim()}&nbsp;
          {((myreason && myreason.length) ?
            <span style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
              "{myreason[0].message}"
            </span> :
            " \"Unknown status code\""
          )}
        </>
      }
      let lineitemWhichpreceedsE1FLoop = false;
      if(onerrecord.match(/^E0 LINITM/i)){
        for(let iii=1;iii<40 && (iii+myindex - 1) <allrecords.length;iii++){
          let recordxx = (allrecords[myindex+iii]?.record||"")+""
          if(recordxx.match(/^E1 F/i))lineitemWhichpreceedsE1FLoop=true;
          if(recordxx.match(/^E0 LINITM/i))break;
        }
      }

      let preceedse1Record = nextrecord.match(/^E1 F/i) || nextrecord2.match(/^E1 F/i);
      let e1fmatch = onerrecord.match(/^E1 F/i) || (onerrecord.match(/^E0/i) && preceedse1Record); 
      if(e1fmatch || lineitemWhichpreceedsE1FLoop){
        return <span style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
          {onerrecord.trim()}
        </span> 
      }
      if(onlyPriorityMessages)return "";
      return onerrecord;
    }
    let highlightedMessagesForLastResponse = (messages) => {
      if (!messages || !messages.length) return "";
      let lastResponse = messages[0];
      console.log('lastResponse: ', lastResponse);
      return <React.Fragment>
        {window.shipmentCountry !== 'GB' && window.shipmentCountry !== 'CA' && <React.Fragment>


          {lastResponse.recordResponse && lastResponse.recordResponse.map((elem, index) => {
            return <React.Fragment key={`rxecordResponse-${index}`}>

              {datamassageCBP(elem.record, lastResponse.recordResponse, index, true) ? <p style={{ color: 'red' }}>
                {datamassageCBP(elem.record,lastResponse.recordResponse,index,true)}
              </p> : ""
              }
            </React.Fragment>
          })}
        </React.Fragment>
        }
      </React.Fragment>
    }



    if (this.state.id !== this.props.id) {
      this.setState({ id: this.props.id }, () => this.getMessages(this.state.id))
    }
    let height = parseInt(this.state.height) - 50;
    return (
      <div className='ace body' style={ window.shipmentCountry !== 'GB' ? { height: height  }:{height: height , padding: "0px 0px 0px 0px"}}>
        <div className='ace item' style={window.shipmentCountry === 'GB' ? {margin : "0px" ,height : "480px"} : null}>
          <div className='ace sub-item'>
            <h4 style={{ display: 'none' }} color='white' ref={this.props.titleRef}>{this.state.aceTitle}</h4>

            {highlightedMessagesForLastResponse(this.state.messages)}
            {
              (!this.state.loading && this.state.messages && this.state.messages.length > 0) ?
                this.state.messages.map((item, i) =>
           
                  item !== 'error occurred' &&<div key={i+"xx"+item.responsetime}>
                    {this.props.recordsRef[i] = []}
                    <div className={'ace res-titles'} style={window.shipmentCountry === 'GB' ? {marginTop : "-30px"} : null}>
                      <img className={'ace down-arrow'} alt={''} src={Images.downArrow} />
                      <p className={'ace-date'} ref={(p) => {
                        this.props.recordsRef[i].push(p)
                      }}>    
                     {window.shipmentCountry !== 'GB' ? window.shipmentCountry==='CA'? this.getDateForDetails(item.summary.substring(item.summary.indexOf("Date")+7,item.summary.indexOf("Status")-1))
                        : moment.utc(item.responsetime).format("MMM DD YYYY HH:mm:ss") : moment.utc(parseInt(item.responsetime)).format("MMM DD YYYY") +" " + 
                        (new Date(parseInt(item.responsetime)).getUTCHours()<10 ? `0${new Date(parseInt(item.responsetime)).getUTCHours()}`: new Date(parseInt(item.responsetime)).getUTCHours()) + ":"
                         + (new Date(parseInt(item.responsetime)).getUTCMinutes()<10 ? `0${new Date(parseInt(item.responsetime)).getUTCMinutes()}`: new Date(parseInt(item.responsetime)).getUTCMinutes())  
                        + ":" +(new Date(parseInt(item.responsetime)).getUTCSeconds()<10 ? `0${new Date(parseInt(item.responsetime)).getUTCSeconds()}`: new Date(parseInt(item.responsetime)).getUTCSeconds()) }
                      </p>
                      { window.shipmentCountry === 'GB' &&
                        <p className={'ace-description'} ref={(p) => {
                          this.props.recordsRef[i].push(p)
                        }}><MessageItem item={item} key={i} closseAce={this.props.closseAce}/></p>
                      }
                      { window.shipmentCountry === 'CA' &&
                      <p className={'ace-description'} ref={(p) => {
                        this.props.recordsRef[i].push(p)
                      }}><MessageDetails item={item} key={i}/></p>
                      }

                      {window.shipmentCountry !== 'GB' && window.shipmentCountry !== 'CA' && <>
                        <p>Status:
                          <span className={'ace-status'} style={{ color: AceResponse.getStatusColor(window.shipmentCountry === 'CA' ? item.recordResponse[0].responsecode : item.txnResponseCode) }}
                            ref={(p) => {
                              this.props.recordsRef[i].push(p)
                            }}>
                            {window.shipmentCountry === 'CA' ? item.recordResponse[0].responsecode : item.txnResponseText}
                          </span>
                          {window.shipmentCountry === 'US' && item.recordResponse[0] && <>
                            {item.recordResponse[0].reasoncode ? <>
                              <br />Reason Code: <b style={{fontWeight:'bold'}}>{item.recordResponse[0].reasoncode}</b>
                            </> : false}
                            {item.recordResponse[0].dispositioncode ? <>
                              <br />Disposition Code: <b style={{fontWeight:'bold'}}>{item.recordResponse[0].dispositioncode}</b>
                            </> : false}

                          </>}
                        </p>
                      </>}
                    </div>


                    { window.shipmentCountry !== 'GB' && window.shipmentCountry!=='CA'&&


                    <p className='ace-titles' style={{ marginTop: '-10px' }} ref={(p) => {
                      this.props.recordsRef[i].push(p)
                    }}>{item.documentTypeName}</p>
                    }


                    { window.shipmentCountry !== 'GB'&& window.shipmentCountry!=='CA' &&


                      item.recordResponse && item.recordResponse.map((elem, index) =>
                        (<p key={`recordResponse-${index}--${i}`} className={'ace line'} ref={(p) => {
                          this.props.recordsRef[i].push(p)
                        }}>{datamassageCBP(elem.record,item.recordResponse,index,false)}</p>)
                      )
                    }
                    
                  </div>
                )
                :
                (this.state.loading ? <div className={'ace loader'}>
                  <RoundLoader color={"lightgrey"} string={"loading response..."} />
                </div> : <div style={{"marginTop": "30px", "textAlign": "center"}}>No Response Available!</div>)
            }
          </div>
          <br />
        </div>
      </div>
    );
  }
}
